import { CardHeader } from "../../../components/CardHeader";
import { SelectInput } from "../../../components/forms/inputs/SelectInput";
import { Country } from "../../../model/Country";
import { FormRow } from "../../common/hook-form";
import * as Inputs from "../../common/hook-form/index";
import { useFormContext } from "react-hook-form";

// Hiding delete option for now. When putting back, pass challenge as props and uncomment all in this file
type Props = {
  isEdit: boolean;
  countries?: Country[];
  // challenge?: ChallengeType;
};

export const ChallengeGeneralInfoSection = ({ isEdit, countries }: Props) => {
  /* const navigate = useNavigate(); */
  const { register, formState } = useFormContext();

  const countryOptions = (countries || [])
    .filter((c) => c.enabled)
    .sort()
    .map((o) => ({
      label: o.englishName,
      value: o.countryCode,
    }));
  /*   const selectedOrganizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  ); */

  /* const { mutateAsync: deleteChallenge, isLoading } = useDeleteChallenge(); */

  /*   const onDelete = async () => {
    try {
      await deleteChallenge({
        organizationKeyName: selectedOrganizationKeyName,
        id: challenge!.id!,
      });
      toastr.success("Success", "You succesfully deleted the challenge");
    } catch (error: any) {
      toastr.error("Error", error.message);
    }
    navigate(routes.challenges(selectedOrganizationKeyName));
  }; */

  return (
    <div className="card">
      <CardHeader
        title={`${isEdit ? "Edit challenge" : "Create new challenge"}`}
        subtitle="Add all details about the challenge and reward below"
      >
        {/*         <div
          className="d-flex flex-row align-items-center"
          style={{ gap: "8px" }}
        >
          {isEdit && (
            <PrimaryButton
              type="button"
              color="white"
              backgroundColor={colors.errorDark}
              hoverColor={colors.errorMedium}
              onClick={onDelete}
            >
              {isLoading ? (
                <FontAwesomeIcon icon={solid("spinner")} pulse spin />
              ) : (
                "Delete"
              )}
            </PrimaryButton>
          )}
        </div> */}
      </CardHeader>
      <div className="card-body">
        <FormRow>
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Challenge name"
            name="title"
            helpText="The official title of the Challenge shown to user in app."
          />
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Admin name"
            name="name"
            helpText="Name shown only to admin users."
          />
        </FormRow>
        <FormRow>
          <Inputs.TextareaFormField
            errors={formState.errors}
            register={register}
            label="Description"
            name="description"
            helpText="Description of challenge. Explain in simple words what the user has to do to achieve the reward."
          />
        </FormRow>
        <FormRow>
          <Inputs.InputFormField
            errors={formState.errors}
            register={register}
            label="Sort key"
            name="sortKey"
            helpText="Enter a number to decide the sorting of the challenge within the challenge list."
          />
        </FormRow>
        <FormRow>
          <SelectInput
            name="countryCode"
            label="Country"
            helperText="For users in what country is this challenge available?"
            options={countryOptions}
          />
        </FormRow>
      </div>
    </div>
  );
};
